const PermissionLevels = require('../auditPolicyConstants').PERMISSION_LEVEL;

class PermissionLevelColumnRenderer {
  constructor(model) {
    this._model = model;
    this._rootElem = document.createElement('permission-level-column');
    this._rootElem.component = this._model;

    this._permissionLevels = PermissionLevels;

    this._registerListeners();
    this.render();
  }

  /********************************************/
  /* START PRIVATE COMPONENT RENDERER METHODS */
  /********************************************/

  _shutdown() {
    return new Promise((resolve /*,reject*/) => {
      this._unregisterListeners();

      this._permissionLevels = undefined;

      this._model = undefined;
      this._rootElem.remove();
      this._rootElem = undefined;
      resolve();
    });
  }

  _registerListeners() {
    this._model.on(
      'PermissionLevel',
      (this._onPermissionLevels = this._onPermissionLevels.bind(this))
    );
  }

  _unregisterListeners() {
    this._model.removeAllListeners('PermissionLevel');
  }

  /*******************************************/
  /* END PRIVATE COMPONENT RENDERER METHODS  */
  /* START PUBLIC COMPONENT RENDERER METHODS */
  /*******************************************/

  /**
   * Stateless method to completely rebuild this component from the _rootElem down.
   * @returns {Promise} An ES6 promise that lets the caller know when the component has finished rendering. If a non
   * Promise is returned the caller will assume the Renderer has completed rendering.
   */

  render() {
    this._setPermissionLevels(this._model.getPermissionLevel());
    return Promise.resolve();
  }

  get rootElement() {
    return this.getRootElement();
  }

  getRootElement() {
    return this._rootElem;
  }

  get model() {
    return this.getModel();
  }

  getModel() {
    return this._model;
  }

  /*******************************************/
  /* END COMPONENT RENDERER METHODS          */
  /* START HANDLER METHODS                   */
  /*******************************************/

  _onPermissionLevels(newVal) {
    this._setPermissionLevels(newVal);
  }

  /*******************************************/
  /* END HANDLER METHODS                     */
  /* START PRIVATE API METHODS               */
  /*******************************************/

  _setPermissionLevels(newVal = 'auditManageLevel1') {
    const permissionLevel = this._permissionLevels[newVal];
    if (permissionLevel) {
      this._rootElem.innerHTML = '';
      this._rootElem.innerText = permissionLevel.title;
    }
  }

  /*******************************************/
  /*  END PRIVATE API METHODS                */
  /*******************************************/
}

export default PermissionLevelColumnRenderer;
